import { useCallback, useEffect } from "react";
import Checkbox from "../sub/components/checkbox";
import { useNavigation } from "@react-navigation/native";
import Button from "../sub/components/PrimaryButton";
import { platform, screenWidth } from "../platform/";
import { COLORS } from "../theme/colors";
import { View, StyleSheet, FlatList } from "react-native";
import ParksStore from "../storage/parksStore";
import AppStore from "../storage/appStore";

const ListItem = ({ data, onCheckboxChange }) => {
  return (
    <View style={styles.listItemContainer}>
      <Checkbox
        color={COLORS.secondary}
        uncheckedColor={COLORS.secondary}
        label={data.title}
        value={data.selected}
        onChange={onCheckboxChange}
        accessibilityLabel={`Park Amenity: ${data.title}`}
      />
    </View>
  );
};

/**
 * Filter Screen
 * @returns {JSX.Element} Filter Screen Component
 */
export default function Filter() {
  const amenities = ParksStore((state) => state.amenities);
  const resetAmenities = ParksStore((state) => state.resetAmenities);
  const updateSelectedAmenities = ParksStore((state) => state.updateSelectedAmenities);
  const toggleAmenity = ParksStore((state) => state.toggleAmenity);
  const getAmenities = ParksStore((state) => state.getAmenities);
  const setLoading = AppStore((state) => state.setLoading);

  const navigation = useNavigation();

  useEffect(() => {
    const fetchAmenities = async () => {
      setLoading(true);
      await getAmenities();
      setLoading(false);
    };
    fetchAmenities();
  }, [getAmenities, setLoading]);

  const toggleSelectedAmenity = useCallback(
    (amenityId) => {
      toggleAmenity(amenityId);
      updateSelectedAmenities();
    },
    [toggleAmenity, updateSelectedAmenities]
  );

  const applyFilters = useCallback(() => {
    if (navigation.canGoBack()) {
      navigation.goBack();
    } else {
      navigation.navigate("ParksMap");
    }
  }, [navigation]);

  const reset = useCallback(() => {
    resetAmenities();
  }, [resetAmenities]);

  const renderItem = useCallback(
    ({ item }) => {
      return <ListItem data={item} onCheckboxChange={() => toggleSelectedAmenity(item.ID)} />;
    },
    [toggleSelectedAmenity]
  );

  return amenities.length > 0 ? (
    <View style={styles.screen}>
      <View style={styles.buttonContainer}>
        <Button title="Reset" onPress={reset} accessibilityLabel={"Reset Amenities"} />
        <Button title="Apply" onPress={applyFilters} accessibilityLabel={"Apply Filters"} />
      </View>
      <FlatList
        style={styles.list}
        accessibilityRole="list"
        accessible={true}
        accessibilityLabel="List of Park Amenities"
        data={amenities}
        renderItem={renderItem}
        keyExtractor={(item) => item.ID}
      />
    </View>
  ) : null;
}
const styles = StyleSheet.create({
  screen: {
    flex: 1,
    width: "100%",
  },
  list: {
    flex: 1,
  },
  listItemContainer: {
    padding: 10,
  },
  buttonContainer: {
    flex: platform === "web" ? 0.05 : 0.02,
    padding: 10,
    flexDirection: "row",
    width: "100%",
    minHeight: 60,
    justifyContent: screenWidth > 600 ? "flex-start" : "center",
  },
});
